import { ErrorHandler } from '@src/components/ErrorHandler';
import { ResultCount } from '@uhg-abyss/web/ui/Pagination';
import PropTypes from 'prop-types';
import React from 'react';

import { Styles } from './includes/styles';

/**
 * ResultsCount
 *
 * Displays the range of results currently displayed along with the total number of results.
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
export function ResultsCount(props) {
  const { pagination, resultsPerPage, totalResults } = props;

  return (
    <ErrorHandler location="src/components/Table-query/components/ResultsCount/ResultsCount.jsx">
      <Styles>
        <ResultCount {...pagination} pageSize={resultsPerPage} resultsTotalCount={totalResults} />
      </Styles>
    </ErrorHandler>
  );
}

ResultsCount.propTypes = {
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
  }),
  resultsPerPage: PropTypes.number,
  totalResults: PropTypes.number,
};

ResultsCount.defaultProps = {
  pagination: {
    currentPage: 0,
    totalPages: 0,
  },
  resultsPerPage: 0,
  totalResults: 0,
};
